import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Card, CardActionArea, CardContent, Stack, Typography, } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ROUTES } from "../breadcrumbs/routeConfig";
var CARDS = [
    {
        to: ROUTES.TEAMS_CREATE,
        icon: _jsx(GroupsIcon, {}),
        title: "Create a Team",
        description: "Manage a squad, track stats & organise matches",
    },
    {
        to: ROUTES.LEAGUES_CREATE,
        icon: _jsx(EmojiEventsIcon, {}),
        title: "Create a League",
        description: "Run seasons, divisions & fixtures",
    },
    {
        to: ROUTES.SEARCH_TEAMS,
        icon: _jsx(SearchIcon, {}),
        title: "Find your Team",
        description: "Search for a team you play for and ask to join",
        lighter: true,
    },
];
export var HomeHub = function (_a) {
    var firstName = _a.firstName, onSkip = _a.onSkip;
    return (_jsxs(Box, { sx: { maxWidth: 560, mx: "auto", p: 2, textAlign: "center" }, children: [_jsxs(Typography, { variant: "h5", sx: { fontWeight: 700, mb: 1 }, children: ["Welcome to Log.Soccer", firstName ? ", ".concat(firstName) : ""] }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 3 }, children: "What would you like to do first?" }), _jsx(Stack, { spacing: 2, children: CARDS.map(function (card) { return (_jsx(Card, { variant: "outlined", sx: { opacity: card.lighter ? 0.85 : 1 }, children: _jsx(CardActionArea, { component: RouterLink, to: card.to, children: _jsxs(CardContent, { sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                textAlign: "left",
                            }, children: [_jsx(Box, { sx: { color: "primary.main", display: "flex" }, children: card.icon }), _jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle1", sx: { fontWeight: 600 }, children: card.title }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: card.description })] })] }) }) }, card.to)); }) }), onSkip && (_jsx(Button, { size: "small", color: "inherit", onClick: onSkip, sx: { mt: 2 }, children: "Skip for now" }))] }));
};
